/* Sunkissed (Oct 7 2026): theme newsletter forms (footer, grid tile, empty bag) sign up in place.
   Before, Sign up did a full page post (through Shopify's captcha) and the reload landed at the top
   of the page. Now, when the Klaviyo subscribe helper from the popup is on the page, the email goes
   straight to the Newsletter list and the block swaps to "You're in" where it is.
   If the helper is missing or Klaviyo fails, the normal post runs, and after the reload the page
   scrolls back to the thank-you block. */
(function () {
  'use strict';
  var CODE = 'SUN10';
  function doneHtml() {
    return '<div class="sk-nl__done" data-sk-ticket-done data-sk-code="' + CODE + '">' +
      '<div class="sk-nl__top"><p class="sk-nl__kicker">You\'re in</p><p class="sk-nl__big">10%</p>' +
      '<p class="sk-nl__line sk-nl__line--sm">off your first order.<br>Launches reach you first.</p></div>' +
      '<div class="sk-nl__bottom"><div class="sk-nl__code"><span>' + CODE + '</span><small>applied at checkout &#10003;</small></div>' +
      '<a class="sk-nl__btn" href="/collections/new-arrivals">Shop new arrivals</a></div></div>';
  }
  function sizeFrom(f) {
    var t = f.querySelector('[data-sk-tags]'); if (!t) return null;
    var m = /(?:^|,\s*)(?:size-)?top-([A-Z]+)/i.exec(t.value) || /size-([A-Z]+)/i.exec(t.value);
    return m ? m[1] : null;
  }
  // capture phase: runs after custom.js validation, before Shopify's captcha handler on the form
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('[data-sk-newsletter-form]') || e.defaultPrevented) return;
    if (typeof window.skKlSubscribe !== 'function') return;
    var em = f.querySelector('input[type=email]'); var email = em ? (em.value || '').trim() : '';
    if (!email) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('button[type=submit]');
    if (btn) { btn.disabled = true; btn.textContent = 'One sec...'; }
    window.skKlSubscribe(email, 'Sunkissed site block', sizeFrom(f)).then(function () {
      f.style.minHeight = f.offsetHeight + 'px';
      f.innerHTML = doneHtml();
      try { localStorage.setItem('sk_code', CODE); localStorage.setItem('sk_subscribed', String(Date.now())); } catch (err) {}
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Sign up'; }
      HTMLFormElement.prototype.submit.call(f);
    });
  }, true);
  // after a normal post, bring the visitor back to the thank-you block instead of the top of the page
  if (/customer_posted=true/.test(location.search)) {
    var back = function () {
      var d = document.querySelector('[data-sk-ticket-done]');
      if (d) d.scrollIntoView({ block: 'center' });
    };
    if (document.readyState === 'complete') setTimeout(back, 300); else window.addEventListener('load', function () { setTimeout(back, 300); });
  }
})();
